module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/8kWjNE/CoverDesign.jpg?1684514561150",
      "alt": "This image is the cover for the book The Playmaker"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Playmaker\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Professional football player Hunter Davis is learning that saying he’s gay is very different from actively being in a relationship with another man—especially in the eyes of his teammates and fans. So when Hunter needs a personal assistant to keep him organized, he asks for a woman in order to prevent tongues from wagging.")]), _vm._v(" "), _c('p', [_vm._v("Montgomery Willis badly needs to find work before he loses everything. There’s just one position at the agency where he applies, but the problem is, he’s not a woman. And he knows nothing about football. Still, Hunter gives him a chance, but only because Monty’s desperate. ")]), _vm._v(" "), _c('p', [_vm._v("Monty soon proves his worth by saving Hunter’s bacon on an important promotional shoot, and Hunter realizes he might have someone special working for him—in more ways than one. Monty’s feelings come to the surface during an outing in the park when Hunter decides to teach Monty a bit about the game, and pictures surface of them in some questionable positions. Hunter is reminded that knowing he’s gay and seeing evidence in the papers are two very different things for the other players, and he might have to choose between two loves: football and Monty.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Andrew Grey\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Dreamspinner Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0